<template>
    <main ref="main" v-if="list_config">
        <div class="se-anchor" :class="{'se-anchor-mobile': $device === 'mobile'}">
            <a-anchor :showInkInFixed="true" :offsetTop="65" :wrapperStyle="style" @click="handleClick">
                <template v-for="v in list_config">
                    <a-anchor-link :href="'#' + v.id" :id="v.id+'a'">
                        <template slot="title">
                            <i class="navi_icon smx-icon" :class="v.class" :style="{color:(v.isHot? 'red' :''),fontWeight: (v.isHot? 500: '')}"></i>
                            <a v-if="$device !== 'mobile'" href="" :title="v.title" class="navi_title" :style="{color:(v.isHot? 'red' :''),fontWeight: (v.isHot? 500: '')}">{{v.title}}</a>
                            <a v-else href="" :title="v.title" class="navi_title" :style="{color:(v.isHot? 'red' :''),fontWeight: (v.isHot? 500: '')}"></a>
                        </template>
                    </a-anchor-link>
                </template>
            </a-anchor>
        </div>
        <div class="se-list" ref="smx-earth-list">
            <template v-for="item in body_config">
                <div :id="item.id"  class="se-list-card">
                    <el-card shadow="never" :body-style="{ padding: '0px' }">
                        <div slot="header" class="clearfix">
                            <span class="se-list-title" :style="{color:(item.isHot? 'red' :''),fontWeight: (item.isHot? 500: '')}">{{item.title}}</span>
                        </div>
                        <el-row class="se-list-row">
                            <el-col :span="spanNum" v-for="(o, index) in item.data" :key="index" style="padding: 10px">
                                <el-card shadow="never" :body-style="{ padding: '10px' }">
                                    <div @click="openUrl(o, item)" style="cursor: pointer">
                                        <div class="image" :style="{backgroundImage: 'url('+o.img+')'}"></div>
                                        <div style="padding: 14px 0px;">
                                            <span class="se-card-title">{{o.title}}</span>
                                            <!--                                            <div class="bottom clearfix">-->
                                            <!--                                                <time class="time">{{ 0.date }}</time>-->
                                            <!--                                            </div>-->
                                        </div>
                                    </div>

                                </el-card>
                            </el-col>
                        </el-row>
                        <!--                        <el-row v-else>-->
                        <!--                            <el-col :span="12" v-for="(o, index) in item.data" :key="index"-->
                        <!--                                    style="padding: 10px">-->
                        <!--                                <el-card shadow="hover" :body-style="{ padding: '10px' }">-->
                        <!--                                    <div @click="openUrl(o.link)" style="cursor: pointer">-->
                        <!--                                        <div class="image" :style="{backgroundImage: 'url('+o.img+')'}"></div>-->
                        <!--                                        <div style="padding: 14px;">-->
                        <!--                                            <span class="se-card-title">{{o.title}}</span>-->
                        <!--                                            &lt;!&ndash;                                            <div class="bottom clearfix">&ndash;&gt;-->
                        <!--                                            &lt;!&ndash;                                                <time class="time">{{ 0.date }}</time>&ndash;&gt;-->
                        <!--                                            &lt;!&ndash;                                            </div>&ndash;&gt;-->
                        <!--                                        </div>-->
                        <!--                                    </div>-->

                        <!--                                </el-card>-->
                        <!--                            </el-col>-->
                        <!--                        </el-row>-->
                    </el-card>
                </div>
            </template>
        </div>
    </main>
    <!--    </div>-->

</template>

<script>
    import tools from './js/tools';
    export default {
        data() {
            return {
                // header_msg: '三维功能示例',
                list_config: null,
                body_config: null,
                style: {
                    // paddingLeft: '20px',
                    height: '100vh'
                },
                spanNum: 6,
            }
        },
        methods: {
            handleClick(e, link) {
                e.preventDefault();
            },
            openUrl(app, group) {
                if (app.link) {
                    const htmlObj = window.document.getElementsByTagName('html')[0];
                    if(htmlObj && htmlObj.scrollTop){
                        tools.setScrollTop(htmlObj.scrollTop);
                    }


                    if(app.type === 'ifram'){
                        this.$router.push({ path: '/demo/hot', query: { link: app.link }});
                    }else{
                        // this.$router.push({path: `/demo/${link}`, query: {link: `${id}a`}});
                        this.$router.push(`/demo/${app.link}`);
                    }


                } else {
                    this.$message('此功能暂未上线,敬请期待!');
                }
            },
        },
        mounted() {
            
            this.list_config = qexc.list_config;
            this.body_config = qexc.body_config;


            if (this.$device === 'mobile') {
                this.spanNum = 12;
            } else {
                this.spanNum = 6;
            }

            const htmlObj = window.document.getElementsByTagName('html')[0];
            const num = tools.getScrollTop();
            if(num){
                htmlObj.scrollTop = num;
            }

            // const link = this.$route.query.link;
            // if (link) {
            //     const anchor = document.getElementById(link);
            //     if (anchor.childNodes[0]) {
            //         anchor.childNodes[0].click();
            //     }
            //
            // }
        },
    }
</script>

<style lang="less">
    @smx-header-height: 65px;
    @smx-link-width: 15%;
    .se-header {
        height: @smx-header-height;
        line-height: @smx-header-height;
        padding: 0;
        background-image: url('/Images/aside_image/2.jpg');
        position: fixed;
        top: 0;
        width: 100vw;
        z-index: 999;

        .icon {
            font-size: 15px;
            color: white;
            z-index: 200;
            margin-left: 16px;
            position: absolute;
        }
    }

    .se-anchor {
        width: @smx-link-width;
        display: inline-block;
    }

    .se-list {
        width: calc(100vw - @smx-link-width);
        position: absolute;
        display: inline-block;
        // margin-top: @smx-header-height;


        &-title {
            font-size: 18px;
            font-weight: 500;
        }

        // 外层
        &-card {
            /*margin: 10px;*/

            /*.box-card{*/
            /*    &:hover{*/
            /*        box-shadow: ;*/
            /*    }*/
            /*}*/

            .el-card {
                border: 0;
                border-left: 1px solid #EBEEF5;
                /*border: 0px;*/
            }
        }

        // 内层
        &-row {
            padding: 10px 10px 0;
            .el-card {
                border: 1px solid #EBEEF5;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

                &:hover {
                    transform: scale(1.05);
                }
            }
        }

        .image {
            width: 100%;
            padding-bottom: 75%; /* 或者padding-bottom: 20%; */
            height: 0;
            background-size: 100% 100%;
        }

        .image:before {
            content: "";
            display: inline-block;
            padding-bottom: 100%;
        }
    }

    .text.item {
        /*width: 300px;*/
        /*float: left;*/
        /*margin: 10px;*/
    }

    .se-anchor-mobile .ant-anchor-link {
        height: 40px !important;
        line-height: 40px !important;
    }

    .ant-anchor-ink {
        display: none;
    }

    .ant-anchor-link {
        /*height: 40px;*/
        /*line-height: 40px;*/
        height: 56px;
        line-height: 56px;
        padding: 0 0 0 20px;

        a {
            /*font-weight: 500;*/
            color: #000;
            text-decoration: none;
        }

        &:hover {
            a {
                color: #0c7aff !important;
            }
        }
    }

    .ant-anchor-link.ant-anchor-link-active {
        background-color: rgb(208, 233, 255) !important;
        color: #1690ff !important;
        border-right: 3px solid #1690ff;

        a {
            color: #0c7aff;
        }
    }


    .navi_title {
        vertical-align: middle;
        text-decoration: none;
    }

    .navi_icon {
        margin-right: 10px;
        width: 14px;
        height: 14px;
        vertical-align: middle;
    }

    .el-main {
        padding: 0;
    }

    .se-card-title {
        max-width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: inline-block;
    }
</style>
